import { useTheme } from '../../../themes/theme.provider';
import { memo } from 'react';
import { useApp } from '../../../hook/app.hook';
import { useUser } from '../../../hook/user.hook';
import SaveStatusComponent from './save-status.component';

const HeaderComponent = () => {
  const { theme } = useTheme();
  const { whiteLabel } = useApp();
  const { candidateConfig } = useUser();

  return (
    <>
      <img
        src={
          whiteLabel?.logo?.url?.default &&
          whiteLabel?.logo?.url?.default.length > 0
            ? whiteLabel?.logo?.url?.default
            : '/images/logo-tr.svg'
        }
        height={32}
        className=""
        alt=""
      />
      <div
        style={{ color: theme.themewhite }}
        className="d-flex align-items-center border-start border-gainsboro px-2"
      >
        <span style={{ color: theme.themewhite }} className={` mx-2 `}>
          {candidateConfig?.candidate?.enrollmentId}
        </span>{' '}
        /
        <SaveStatusComponent className="mx-2" />
      </div>
    </>
  );
};

export default memo(HeaderComponent);
